import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products, columns = 4 }) => {
  const colClass =
    columns === 3
      ? "sm:grid-cols-2 lg:grid-cols-3"
      : "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4";
  return (
    <div
      className={`grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 ${colClass}`}
      data-testid="product-grid"
    >
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  );
};

export default ProductGrid;
